import BaseModel from "./base/baseModel";

export default class ManipulacaoLoteEstoqueModel extends BaseModel {
    produtoDescricao: string = null;
    movimentacaoEstoqueId?: number = null;
    manipulacaoOrdemId?: number = null;
    quantidadePesagem = 0;
    quantidadeAtual = 0;
    dataValidade: Date = null;
    produtoLoteId?: number = null;
    produtoId?: number = null;
    quantidadeAlteradaManualmente = false;
    produtoLoteDescricao: string = null;
    unidadeMedida: string = null;
}
